import { Avatar, Badge, IconButton, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { useState } from 'react';
import { ReactComponent as PenIcon } from '../../../../assets/icons/pencil-2.svg';
import { primaryLight } from '../../../../utils/color';
import AvatarEditorModal from './AvatarEditorModal';
import useUserCompany from '../../../../utils/hooks/useUserCompany';

const SidebarProfileBanner = () => {
  const [open, setOpen] = useState(false);

  const { company: userCompany } = useUserCompany();

  return (
    <Stack direction="column" gap={1} justifyContent="center" alignItems="center">
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={
          <IconButton
            onClick={() => setOpen(true)}
            sx={{
              width: '25px',
              height: '25px',
              bgcolor: 'primaryLight.50',
              borderRadius: '4px',
              padding: '2px',
              '&:hover': {
                bgcolor: 'primaryLight.100',
              },
            }}
          >
            <PenIcon fill={primaryLight[500]} />
          </IconButton>
        }
      >
        <Avatar
          alt={userCompany?.name}
          src={userCompany?.avatar}
          sx={{
            height: '5rem',
            width: '5rem',
            fontSize: 40,
            backgroundColor: userCompany?.avatar ? 'white' : 'primaryDark.400',
          }}
        />
      </Badge>
      <Typography variant="headline4">{userCompany?.name}</Typography>
      <AvatarEditorModal open={open} setOpen={setOpen} />
    </Stack>
  );
};

export default SidebarProfileBanner;
